import React from 'react';

const Button = ({ 
  children, 
  variant = 'contained', 
  color = 'primary', 
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props 
}) => {
  const baseClasses = "px-6 py-3 font-semibold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    contained: "bg-[#027BC6] text-white hover:bg-[#015A8A] focus:ring-[#027BC6] shadow-[0px_5px_20px_#00000022]",
    outlined: "border-2 border-[#027BC6] text-[#027BC6] hover:bg-[#027BC6] hover:text-white focus:ring-[#027BC6]",
    text: "text-[#027BC6] hover:bg-[#027BC6] hover:bg-opacity-10 focus:ring-[#027BC6]"
  };

  const sizeClasses = {
    small: "px-4 py-2 text-sm",
    medium: "px-6 py-3 text-base",
    large: "px-8 py-4 text-lg"
  };

  const disabledClasses = disabled || loading ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`
        ${baseClasses}
        ${variantClasses[variant]}
        ${sizeClasses.large}
        ${fullWidth ? 'w-full' : ''}
        ${disabledClasses}
        ${className}
      `}
      style={{ height: '56px', minHeight: '56px' }}
      {...props}
    >
      <div className="flex items-center justify-center h-full">
        {loading ? (
          <div className="animate-spin rounded-full h-[20px] w-[20px] border-b-2 border-white"></div>
        ) : (
          <span className="text-[14px] font-semibold">{children}</span>
        )}
      </div>
    </button>
  );
};

export default Button;